import React, { useState } from 'react';
import './PricingPage.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

const PricingPage = () => {
    const navigate = useNavigate();
    const [isAnnual, setIsAnnual] = useState(false);

    const handleLogout = () => {
        signOut(auth).then(() => {
            navigate('/login');
        }).catch((error) => {
            console.error("Sign out error", error);
        });
    };

    const handleNavClick = (id) => {
        navigate(id);
    };

    // Smart handler: checks login, passes plan name via URL
    const handlePurchaseClick = (planName) => {
        const user = auth.currentUser;
        if (user) {
            navigate(`/checkout?plan=${planName}`);
        } else {
            navigate('/login', { state: { from: `/checkout?plan=${planName}` } });
        }
    };

    return (
        <div className="pricing-container">
            {/* Navigation Bar */}
            <nav className="unauth-navbar">
                <div className="unauth-logo" onClick={() => handleNavClick('/')}>
                    <FontAwesomeIcon icon="pills" className="unauth-header-icon" /> ClinicSync
                </div>
                {auth.currentUser && <button onClick={handleLogout} className="logout-button">Logout</button>}
            </nav>

            <h1>Choose Your Plan</h1>
            <p>Simple and transparent pricing for your clinic.</p>

            <div className="billing-toggle-container">
                <span className={`toggle-label ${!isAnnual ? 'active' : ''}`}>Monthly</span>
                <label className="switch">
                    <input type="checkbox" checked={isAnnual} onChange={() => setIsAnnual(!isAnnual)} />
                    <span className="slider round"></span>
                </label>
                <span className={`toggle-label ${isAnnual ? 'active' : ''}`}>
                    Annual <span className="discount-badge">-10%</span>
                </span>
            </div>

            <div className="pricing-cards">
                <div className="card">
                    <div className="card-header">
                        <h2>Starter</h2>
                        <p className="desc">For businesses looking to test the power of ClinicSync, good for learning the softwares importance in your clinic</p>
                        <div className="price-container">
                            <span className="price">₹{isAnnual ? '416' : '499'}</span>
                            <span className="billing-cycle">/mo.</span>
                        </div>
                        {isAnnual && <p className="annual-billed">Billed ₹4999 yearly</p>}
                    </div>
                    <div className='ul-and-cta-btn'>
                        <p className="features-title">The Basics for Clinic Success:</p>
                        <ul>
                            <li><span className="check-icon">✓</span> 1 Clinic</li>
                            <li><span className="check-icon">✓</span> Up to 100 Patients</li>
                            <li><span className="check-icon">✓</span> Email Support</li>
                            <li><span className="check-icon">✓</span> Basic Reporting</li>
                        </ul>
                        <button onClick={() => handleNavClick('/signup')}>Get Started</button>
                    </div>
                </div>

                <div className="card popular">
                    <div className="card-header">
                        <h2>Professional</h2>
                        <p className="desc">For businesses with potential looking to grow their clinic to the next level</p>
                        <div className="price-container">
                            <span className="price">₹{isAnnual ? '825' : '999'}</span>
                            <span className="billing-cycle">/mo.</span>
                        </div>
                        {isAnnual && <p className="annual-billed">Billed ₹9,900 yearly</p>}
                    </div>
                    <div className='ul-and-cta-btn'>
                        <p className="features-title">Everything in Starter Plus:</p>
                        <ul>
                            <li><span className="check-icon">✓</span> Up to 5 Clinics</li>
                            <li><span className="check-icon">✓</span> Unlimited Patients</li>
                            <li><span className="check-icon">✓</span> WhatsApp & SMS Reminders</li>
                            <li><span className="check-icon">✓</span> 24/7 Support</li>
                            <li><span className="check-icon">✓</span> Advanced Reporting</li>
                        </ul>
                        <button onClick={() => handleNavClick('/signup')}>Get Started</button>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h2>Enterprise</h2>
                        <p className="desc">Enterprise level software with dedicated support, databases and complete security</p>
                        <div className="price-container">
                            <span className="price price-text">Let's Talk</span>
                        </div>
                        <p className="annual-billed transparent-text">Custom plan</p>
                    </div>
                    <div className='ul-and-cta-btn'>
                        <p className="features-title">Everything in Professional Plus:</p>
                        <ul>
                            <li><span className="check-icon">✓</span> Unlimited Clinics</li>
                            <li><span className="check-icon">✓</span> Custom Branding</li>
                            <li><span className="check-icon">✓</span> Dedicated Support</li>
                            <li><span className="check-icon">✓</span> Advanced Analytics</li>
                            <li><span className="check-icon">✓</span> Custom Feature Development</li>
                        </ul>
                        <button onClick={() => navigate('/contact')}>Contact Us</button>
                    </div>
                </div>
            </div>
            <p className='cta-text'>Please purchase a plan to continue using the software.</p>

            <footer className="unauth-footer">
                <div className="unauth-footer-content">
                    <p>&copy; {new Date().getFullYear()} ClinicSync. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default PricingPage;
